import React from "react"
import { Card, CardBody, Badge } from "reactstrap"
import { useNavigate } from "react-router-dom"
import CustomHeaderTitle from "components/Common/CustomHeaderTitle"
import GeneralTables from "components/Common/GeneralTable"
import ActionColumns from "components/Common/GeneralTable/ActionColumns"

const UserListComponent = ({
  data,
  error,
  loading,
  onPageClick,
  onSearch,
  onChangeRowNumber,
  onChangeOrdering,
  onClickDelete,
  handleDeleteFunc,
}) => {
  const navigate = useNavigate()
  return (
    <React.Fragment>
      <Card>
        <CardBody>
          {/*
            CustomHeaderTitle Component Props:
            
            - loading: Boolean flag to display loading state
            - title: String to display as the header title
            - rowCount: Boolean to show/hide the row number selector
            - lgColumn: Number to control the width of columns based on layout needs
            - onChangeRowNumber: Callback function to handle row number selection change
            - orderingList: Boolean to show/hide ordering dropdown
            - onChangeOrdering: Callback function triggered when the ordering option is changed
            - searchBox: Boolean to show/hide search input box
            - onSearchHandler: Function called on key up in the search box
            - rightBtn: Boolean to show/hide right-side button (for example, a back button)
            - rightBtnTitle: String for setting the right button's label
            - rightBtnRoute: Route for the right button's navigation
            - exportBtn: Boolean to show/hide export button
            - onExportBtnClick: Callback for when the export button is clicked
            - exportBtnLoading: Boolean flag to show loading state during export functionality
            - advnacedSearchBtn: Boolean to show/hide advanced search button
            - advnacedSearchBtnTitle: String to display the advanced search button label
            - onAdvancedSearch: Callback function when the advanced search button is clicked (used to toggle collapse)
            - orderingOptions: Array of options to populate the ordering dropdown (value and name pair)
          */}
          <CustomHeaderTitle
            loading={loading}
            title={"List"}
            rowCount={true}
            onChangeRowNumber={onChangeRowNumber}
            orderingList={true}
            onChangeOrdering={onChangeOrdering}
            searchBox={true}
            onSearchHandler={onSearch}
            rightBtn={true}
            rightBtnTitle={"Add user"}
            rightBtnRoute={"/add-user"}
            orderingOptions={[
              { value: "id", name: "ID" },
              { value: "name", name: "Name" },
            ]}
          />
          {/*
            GeneralTables Component Props:

            - data: Array containing the data to be displayed in the table
            - loading: Boolean indicating the loading state of the table
            - parentCheckbox: Boolean to determine if a parent checkbox is included in the table
            - headers: Array of strings representing the column headers for the table
            - pagination: Object containing pagination metadata and a callback function:
                - meta: Object for pagination details (e.g., page number, total items)
                - onPageClick: Callback function to handle page number changes
            - renderItem: Function to render each row/item in the table using the provided data
          */}
          <GeneralTables
            data={data?.data}
            loading={loading}
            headers={[
              "#",
              "Name",
              "Email",
              "Role",
              "Province",
              "Item Category",
              "Providers",
              "Warehouses",
              "IP",
              "Projects",
              "Action",
            ]}
            pagination={{ meta: data?.meta, onPageClick: onPageClick }}
            renderItem={(user, index) => (
              <tr key={index}>
                <th scope="row">{data?.meta?.from + index}</th>
                <td>{user.name}</td>
                <td>{user.email}</td>
                <td>{user.role?.name}</td>
                <td>{user.provincesName.join(" - ")}</td>
                <td>{user.itemCategoriesName.join(" - ")}</td>
                <td>{user?.providersName.join(" - ")}</td>
                <td>{user?.warehousesName.join(" - ")}</td>
                <td>{user.ipsName?.join(" - ")}</td>
                <td>{user.projectsName?.join(" - ")}</td>
                <td>
                  {/* Render action columns with Edit and Delete options for each user  */}
                  <ActionColumns
                    data={user}
                    enableEdit={true}
                    enableDelete={true}
                    editRoute={`/edit-user/${user.id}`}
                    onClickDelete={onClickDelete}
                  />
                </td>
              </tr>
            )}
          />
        </CardBody>
      </Card>
    </React.Fragment>
  )
}

export default UserListComponent
